import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "divide-y divide-gray-200 border-y border-gray-200" }
const _hoisted_2 = { class: "text-sm text-gray-500" }
const _hoisted_3 = { class: "text-sm text-gray-500" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "flex w-full justify-end gap-3" }

import { computed } from 'vue'

import NeueButton from '@/components/neue/NeueButton.vue'
import TheModal from '@/components/TheModal.vue'
import { dropCountLabel, formatDropDay, formatRecipientCount, formatReminderAt } from '@/helpers/dropImpact'


export default {
  __name: 'DropImpactWarningModal',
  props: {
  isOpen: { type: Boolean, default: false },
  affectedDrops: { type: Array, default: () => [] },
  actionNoun: { type: String, default: 'change' },
  canUndo: { type: Boolean, default: true }
},
  emits: ['undo', 'keep'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const title = computed(
  () => `This ${props.actionNoun} leaves ${dropCountLabel(props.affectedDrops.length)} with no fulfillment date`
)

const dropDates = drop => (drop.dates || []).map(formatDropDay).join(', ')

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(TheModal, {
    "is-open": __props.isOpen,
    "modal-title": title.value,
    "footer-full-width": true,
    onCloseModal: _cache[2] || (_cache[2] = $event => (emit('keep')))
  }, {
    main: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.affectedDrops, (drop) => {
          return (_openBlock(), _createElementBlock("li", {
            key: drop.id,
            class: "py-3",
            "data-test": "affected-drop"
          }, [
            _createVNode(_component_router_link, {
              to: `/store/drops/${drop.id}`,
              class: "text-sm font-medium text-gray-900 hover:text-blue-600"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(drop.description), 1)
              ]),
              _: 2
            }, 1032, ["to"]),
            _createElementVNode("p", _hoisted_2, _toDisplayString(dropDates(drop)), 1),
            _createElementVNode("p", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(formatRecipientCount)(drop.recipient_count)) + " ", 1),
              (drop.reminder_at)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, ", reminder scheduled " + _toDisplayString(_unref(formatReminderAt)(drop.reminder_at)), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mt-4 text-sm text-gray-600" }, " Reminder texts and auto-charges for these drops will not send until a fulfillment date is open again. ", -1))
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        (__props.canUndo)
          ? (_openBlock(), _createBlock(NeueButton, {
              key: 0,
              type: "red",
              "data-test": "undo",
              onClick: _cache[0] || (_cache[0] = $event => (emit('undo')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Undo " + _toDisplayString(__props.actionNoun), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(NeueButton, {
          type: "primary",
          "data-test": "keep",
          onClick: _cache[1] || (_cache[1] = $event => (emit('keep')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Keep " + _toDisplayString(__props.actionNoun), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["is-open", "modal-title"]))
}
}

}